import { useEffect } from 'react'
import { PERFORMANCE_AND_RIG_FLOOR_KPIS_METHODOLOGY, PERFORMANCE_KPIS_METHODOLOGY } from '../components/common'
import { SelectOptions } from '../types'
import { hasSelectedEquipment } from '../utils/functions'

interface UseRigFloorLogicProps {
    selectedMethodology: SelectOptions
    setEnableRigFloor: React.Dispatch<React.SetStateAction<boolean>>
    setIsActButtonDisabled: React.Dispatch<React.SetStateAction<boolean>>
    selectedHydratongEquipment: SelectOptions
    selectedHydrarackerEquipment: SelectOptions
    selectedTopDriveEquipment: SelectOptions
    reprocessingSpan?: string
}

export const useRigFloorMethodologyLogic = ({
    selectedMethodology,
    setEnableRigFloor,
    setIsActButtonDisabled,
    selectedHydratongEquipment,
    selectedHydrarackerEquipment,
    selectedTopDriveEquipment,
    reprocessingSpan
}: UseRigFloorLogicProps): void => {
    useEffect(() => {
        if (typeof setIsActButtonDisabled !== 'function') return // is undefined in the first render

        if (selectedMethodology?.value === PERFORMANCE_AND_RIG_FLOOR_KPIS_METHODOLOGY) {
            setEnableRigFloor(true)
            setIsActButtonDisabled(
                !hasSelectedEquipment([
                    selectedHydratongEquipment,
                    selectedHydrarackerEquipment,
                    selectedTopDriveEquipment
                ])
            )
        } else if (selectedMethodology?.value === PERFORMANCE_KPIS_METHODOLOGY) {
            setEnableRigFloor(false)
            setIsActButtonDisabled(false)
        } else {
            setIsActButtonDisabled(true)
        }
    }, [
        reprocessingSpan,
        selectedHydrarackerEquipment,
        selectedHydratongEquipment,
        selectedMethodology,
        selectedTopDriveEquipment,
        setEnableRigFloor,
        setIsActButtonDisabled
    ])
}
